<script setup lang="ts">
//
</script>

<template>
  <div
    class="grid grid-cols-1 gap-5 xl:grid-cols-4 [&>aside]:relative [&>aside]:z-0 [&>aside]:space-y-5 xl:[&>aside>.ReviveAd]:sticky xl:[&>aside>.ReviveAd]:top-32 xl:[&>aside>.ReviveAd]:z-20"
  >
    <slot name="left-sidebar" />
    <div class="xl:col-span-3">
      <slot />
    </div>
    <slot name="right-sidebar" />
  </div>
</template>
